export default __webpack_public_path__ + "static/4-8f64cce5dc59d84df4d0daf1153cb51d.png";